import React from "react";
import SubTitle from "../../../../utils/subtitle/SubTitle";
import { Colors } from "../../../../utils/colors/colors";
import { FaPlus, FaMinus } from "react-icons/fa";
import { IServices, ISubHeaderType } from "../../../../types/types";




export default function Services(props: IServices) {

  
  const options = [
    "Service Operations",
    "HR Technology",
    "Product Development",
    "Brand Design",
    "Digital Development",
  ];

  const handleOptionClick = (option: string) => {
    if (props.serviceType.includes(option)) {
      props.setServiceType(props.serviceType.filter((item) => item !== option));
    } else {
      props.setServiceType([...props.serviceType, option]);
    }
  };

  const { whiteColor, secondaryColor } = Colors();

  return (
    <div
      className="mb-5"
      data-aos="fade-up"
      data-aos-once="true"
    >
      <SubTitle
        textColor={whiteColor}
        text={"How can we help you?"}
        type={ISubHeaderType.h3}
      />

      <div className="service-main-div">
        {options.map((option) => (
          <div
            key={option}
            onClick={() => handleOptionClick(option)}
            data-aos="fade-up"
            data-aos-once="true"
            className="service-div my-2"
            style={{
              backgroundColor: props.serviceType.includes(option)
                ? secondaryColor
                : "",
            }}
          >
            {option}

            {props.serviceType.includes(option) ?
              <FaMinus color="#e9e9ed" size="10" />
              :
              <FaPlus color="#e9e9ed" size="10" />
            }
          </div>
        ))}
      </div>
    </div>
  );
}
